import { useState } from "react";

import { SignUpForm, CodeForm, PasswordForm, InfoForm } from "./Procedure";
import Courasel from "../../Courasel/Courasel";

import image from "../../../Assets/Signin/sign1.jpg";
import image2 from "../../../Assets/Signin/sign2.jpg";
import image3 from "../../../Assets/Signin/sign3.jpg";

const SignUp = () => {
  const data = [
    {
      title: "Invoices",
      text: "Make payments easier for your customers with online invoices they can pay with their MPESA, Card or Crypto payments.",
      image,
    },
    {
      title: "Payment links",
      text: "Start accepting payments, subscriptions and donations through your dedicated and custom payment link.",
      image: image2,
    },
    {
      title: "Payouts",
      text: "Disburse payments to vendors, part-time staff or service providers, through instant file uploads or easily integrated APIs.",
      image: image3,
    },
  ];

  const [step, setStep] = useState("create");
  const setNextStep = (str) => {
    setStep(str);
  };

  const [index, setCurrentIndex] = useState(0);
  const getCurrentIndex = (num) => {
    setCurrentIndex(num);
  };

  return (
    <div className="bg-white text-white h-screen px-6 md:px-0 md:h-[100vh] md:overflow-hidden">
      <div className="flex flex-col justify-center h-full md:flex-row">
        {step === "create" ? (
          <SignUpForm clickFunction={setNextStep} />
        ) : step === "code" ? (
          <CodeForm clickFunction={setNextStep} />
        ) : step === "password" ? (
          <PasswordForm clickFunction={setNextStep} />
        ) : step === "info" ? (
          <InfoForm />
        ) : (
          ""
        )}
        <div className="hidden h-[100vh] relative lg:block md:w-1/2">
          <Courasel
            direction="X"
            flex="row"
            duration="0"
            delay={5000}
            arrows="flex"
            getIndex={getCurrentIndex}
          >
            {data.map((item, i) => (
              <div
                key={i}
                className="relative -mt-1 height w-full m-auto min-w-full"
              >
                <img
                  src={item.image}
                  alt=""
                  className="h-[100vh] w-full object-cover brightness-50"
                />
                <div className="flex flex-col justify-end absolute left-0 top-0 w-full h-full p-16 space-y-3">
                  <h2 className="text-4xl font-semibold">{item.title}</h2>
                  <p className="md:w-1/2">{item.text}</p>
                </div>
              </div>
            ))}
          </Courasel>

          {/* indicators */}
          <div className="absolute left-16 bottom-5 w-max flex flex-row justify-center gap-4 mt-5">
            {data.map((child, i) => (
              <p
                className={`cursor-pointer rounded-full duration-500 px-3 py-[6px] ${
                  data.indexOf(child) === index
                    ? `bg-brandColor px-6`
                    : `bg-transparent border`
                }`}
                key={i}
              ></p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
